import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useOrgData } from '../hooks/useOrgData';
import { CategoryTag, fmtDate } from '../components/ui';

export function Cancelados() {
  const { currentOrgId } = useAuth();
  const { loading, summaries } = useOrgData(currentOrgId);
  const nav = useNavigate();

  const cancelados = useMemo(
    () =>
      summaries
        .filter((s) => s.lifecycle === 'cancelado')
        .sort((a, b) => `${a.brand}${a.name}`.localeCompare(`${b.brand}${b.name}`)),
    [summaries],
  );

  return (
    <>
      <div className="topbar">
        <h1>Projetos cancelados</h1>
        <div className="stat-strip">
          <div className="stat-chip">
            <span className="n tabular">{cancelados.length}</span>
            <span className="l">Cancelados</span>
          </div>
        </div>
      </div>

      <div className="content">
        {loading ? (
          <div className="center-note">Carregando…</div>
        ) : cancelados.length === 0 ? (
          <div className="card card-pad">
            <p className="muted">Nenhum projeto cancelado. 🎉</p>
          </div>
        ) : (
          <div className="card">
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Marca</th>
                    <th>Projeto</th>
                    <th>Categoria</th>
                    <th>Nº SAP</th>
                    <th>Aberto em</th>
                  </tr>
                </thead>
                <tbody>
                  {cancelados.map((s) => (
                    <tr key={s.productId} className="clickable" onClick={() => nav(`/produto/${s.productId}`)}>
                      <td className="muted">{s.brand}</td>
                      <td style={{ fontWeight: 600 }}>{s.name}</td>
                      <td><CategoryTag category={s.category} /></td>
                      <td className="tabular muted">{s.sapCode ?? '—'}</td>
                      <td className="tabular muted">{fmtDate(s.openedAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="muted" style={{ fontSize: 12, padding: '10px 14px' }}>
              Para reativar um projeto, abra-o e mude o ciclo de vida para “Ativo”.
            </p>
          </div>
        )}
      </div>
    </>
  );
}
